<template>
  <q-page class="q-pa-md">
    <div class="row q-col-gutter-md q-mt-md">
      <div :class="['col-12', minimized.topLeft ? 'col-md-11' : minimized.topRight ? 'col-md-1' : 'col-md-6']">
        <q-card v-if="!minimized.topRight" flat bordered class="q-pa-md card-fixed-height">
          <div class="row">
            <div class="col text-weight-bold">
              Crop Tickets
            </div>
          </div>
          <q-card-section class="card-content-scroll">
            <div class="row justify-end">
              <q-btn
                color="primary"
                label="New Job"
                @click="onAddJob"
                class="q-mb-sm q-ml-sm"
                size="sm"
              />
            </div>
            <q-table
              :rows="formattedJobs"
              :columns="jobColumns"
              :pagination="{ rowsPerPage: 0 }"
              row-key="id"
              flat
            >
              <template v-slot:body-cell-actions="props">
                <q-td :props="props">
                 <q-btn
                   size="xs"
                   color="primary"
                   label="Add Tickets"
                   @click="$router.push(`/crop_ticket/add/${props.row.id}`)"
                 />
               </q-td>
             </template>
            </q-table>

          </q-card-section>
        </q-card>
      </div>

      <!-- Top Left Section (Minimizable) -->
      <div :class="['col-12', minimized.topLeft ? 'col-md-1' : minimized.topRight ? 'col-md-11' :'col-md-6']">
        <q-card v-if="!minimized.topLeft" flat bordered class="q-pa-md card-fixed-height">
          <div class="row">
            <div class="col text-weight-bold">
              Delivery Tickets
            </div>
          </div>
          <q-card-section class="card-content-scroll">
            <div class="row justify-end">
              <q-btn
                color="primary"
                label="Add Delivery Ticket"
                @click="onAddDeliveryTicket"
                class="q-mb-sm q-ml-sm"
                size="sm"
              />
            </div>
            <q-table
              :rows="formattedDeliveryTickets"
              :columns="deliveryColumns"
              :pagination="{ rowsPerPage: 0 }"
              row-key="id"
              flat
            >
              <template v-slot:body-cell-actions="props">
                <q-td :props="props">
                 <q-btn
                   size="xs"
                   color="primary"
                   label="Edit"
                   @click="$router.push(`/delivery_ticket/edit/${props.row.id}`)"
                 />
               </q-td>
             </template>
            </q-table>
          </q-card-section>
        </q-card>
      </div>
    </div>

    <div class="row q-col-gutter-md q-mt-md">
      <!-- Bottom Left Section (Minimizable) -->
      <div :class="['col-12', minimized.bottomLeft ? 'col-md-1' : minimized.bottomRight ? 'col-md-1' : 'col-md-6']">
        <q-card v-if="!minimized.bottomLeft" flat bordered class="q-pa-md card-fixed-height">
          <div class="row">
            <div class="col text-weight-bold">
              Haul Tickets
            </div>
          </div>
          <q-card-section class="card-content-scroll">
            <div class="row justify-end">
              <q-btn
                color="primary"
                label="Add Haul Ticket"
                @click="onAddHaulTicket"
                class="q-mb-sm q-ml-sm"
                size="sm"
              />
            </div>
            <q-table
              :rows="formattedHaulTickets"
              :columns="haulColumns"
              :pagination="{ rowsPerPage: 0 }"
              row-key="id"
              flat
            >
              <template v-slot:body-cell-actions="props">
                <q-td :props="props">
                 <q-btn
                   size="xs"
                   color="primary"
                   label="Edit"
                   @click="$router.push(`/haul_ticket/edit/${props.row.id}`)"
                 />
               </q-td>
             </template>
            </q-table>
          </q-card-section>
        </q-card>
      </div>

      <!-- Bottom Right Section (Minimizable) -->
      <!-- Ticket Counts -->
      <div :class="['col-12', minimized.bottomLeft ? 'col-md-11' : minimized.bottomRight ? 'col-md-1' : 'col-md-6']">
        <q-card v-if="!minimized.bottomRight" flat bordered class="q-pa-md card-fixed-height">
          <q-card-section class="row items-center">
            <div class="col">
              <div class="text-h6">Ticket Counts</div>
            </div>
          </q-card-section>

          <q-card-section v-if="loading" class="text-center">
            <q-spinner size="md" color="primary" />
          </q-card-section>

          <q-card-section v-else>
            <div class="row q-col-gutter-md">
              <div class="col-12 col-sm-4">
                <q-card flat bordered class="ticket-count-tile">
                  <q-card-section>
                    <div class="text-caption text-grey-7">Crop Tickets</div>
                    <div class="text-h4 text-weight-bold">{{ ticketCounts.ticket_crop_count }}</div>
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-12 col-sm-4">
                <q-card flat bordered class="ticket-count-tile">
                  <q-card-section>
                    <div class="text-caption text-grey-7">Delivery Tickets</div>
                    <div class="text-h4 text-weight-bold">{{ ticketCounts.ticket_delivery_count }}</div>
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-12 col-sm-4">
                <q-card flat bordered class="ticket-count-tile">
                  <q-card-section>
                    <div class="text-caption text-grey-7">Haul Tickets</div>
                    <div class="text-h4 text-weight-bold">{{ ticketCounts.ticket_haul_count }}</div>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
import axios from 'axios';
import { watch } from 'vue';
import { selectedYear } from '@/store/store'

export default {
  name: 'HomePage',
  data() {
    return {
      jobs: [],
      delivery_tickets: [],
      haul_tickets: [],
      minimized: {
        topLeft: false,
        topRight: false,
        bottomLeft: false,
        bottomRight: false,
      },
      loading: false,
      ticketCounts: { ticket_crop_count: 0, ticket_delivery_count: 0, ticket_haul_count: 0 },
      jobColumns: [
        { name: 'date', label: 'Date', field: 'date', align: 'left' },
        { name: 'producer_name', label: 'Producer', field: 'producer_name', align: 'left' },
        { name: 'customer_name', label: 'Customer', field: 'customer_name', align: 'left' },
        { name: 'crop_name', label: 'Crop', field: 'crop_name', align: 'left' },
        { name: 'field_name', label: 'Field', field: 'field_name', align: 'left' },
        { name: 'actions', label: 'Actions', align: 'center' }
      ],
      deliveryColumns: [
        { name: 'date', label: 'Date', field: 'date', align: 'left' },
        { name: 'producer_name', label: 'Producer', field: 'producer_name', align: 'left' },
        { name: 'customer_name', label: 'Customer', field: 'customer_name', align: 'left' },
        { name: 'crop_name', label: 'Crop', field: 'crop_name', align: 'left' },
        { name: 'driver_name', label: 'Driver', field: 'driver_name', align: 'left' },
        { name: 'actions', label: 'Actions', align: 'center' }
      ],
      haulColumns: [
        { name: 'date', label: 'Date', field: 'date', align: 'left' },
        { name: 'feedmill_name:', label: 'Feedmill', field: 'feedmill_name', align: 'left' },
        { name: 'customer_name', label: 'Customer', field: 'customer_name', align: 'left' },
        { name: 'feed_id', label: 'Feed', field: 'feed_name', align: 'left' },
        { name: 'driver_name', label: 'Driver', field: 'driver_name', align: 'left' },
        { name: 'actions', label: 'Actions', align: 'center' }
      ],
    };
  },
  computed: {
    formattedJobs() {
      return this.jobs.map(job => ({
        ...job,
        producer_name: job.producer_id?.name || 'N/A',
        customer_name: job.customer_id?.name || 'N/A',
        field_name: job.field_id?.name || 'N/A',
        crop_name: job.crop_id?.crop || 'N/A',
        date: new Date(job.date).toLocaleDateString(),
      }));
    },
    formattedDeliveryTickets() {
      return this.delivery_tickets.map(ticket => ({
        ...ticket,
        producer_name: ticket.producer_id?.name || 'N/A',
        customer_name: ticket.customer_id?.name || 'N/A',
        crop_name: ticket.crop_id?.crop || 'N/A',
        driver_name: ticket.driver_id?.name || 'N/A',
        date: new Date(ticket.date).toLocaleDateString(),
      }));
    },
    formattedHaulTickets() {
      return this.haul_tickets.map(ticket => ({
        ...ticket,
        feedmill_name: ticket.feedmill_id?.name || 'N/A',
        customer_name: ticket.customer_id?.name || 'N/A',
        feed_name: ticket.feed_id?.name || 'N/A',
        driver_name: ticket.driver_id?.name || 'N/A',
        date: new Date(ticket.date).toLocaleDateString(),
      }));
    }
  },
  created() {
    this.fetchJobs();
    this.fetchDeliveryTickets();
    this.fetchHaulTickets();
    this.fetchTicketCounts();

    watch(selectedYear, () => {
      this.fetchJobs();
      this.fetchDeliveryTickets();
      this.fetchHaulTickets();
      this.fetchTicketCounts();
    });
  },
  methods: {
    async fetchTicketCounts() {
      this.loading = true;
      try {
        const response = await axios.get('/api/v1/ticket_counts/', { params: { selectedYear: selectedYear.value } });
        this.ticketCounts = response.data;
      } catch (error) {
        console.error('Error fetching ticket counts:', error);
      }
      this.loading = false;
    },
    async fetchJobs() {
      try {
        const response = await axios.get('/api/v1/job/jobs/', {
          params: { year: selectedYear.value, page_size: 10 },
        });
        this.jobs = response.data.results;
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    },
    async fetchDeliveryTickets() {
      try {
        const response = await axios.get('/api/v1/ticket_delivery/ticket-deliveries/', {
          params: { year: selectedYear.value, page_size: 10 },
        });
        this.delivery_tickets = response.data.results;
      } catch (error) {
        console.error('Error fetching delivery tickets:', error);
      }
    },
    async fetchHaulTickets() {
      try {
        const response = await axios.get('/api/v1/ticket_haul/ticket-hauls/', {
          params: { year: selectedYear.value, page_size: 10 },
        });
        this.haul_tickets = response.data.results;
      } catch (error) {
        console.error('Error fetching haul tickets:', error);
      }
    },
    onAddJob() {
      this.$router.push('/job/add');
    },
    onAddDeliveryTicket() {
      this.$router.push('/delivery_ticket/add');
    },
    onAddHaulTicket() {
      this.$router.push('/haul_ticket/add');
    },
  }
};
</script>

<style>
  .q-table__control {
    display: none !important;
  }

  .card-fixed-height {
    height: 450px;
    display: flex;
    flex-direction: column;
  }

  .card-content-scroll {
    flex: 1 1 auto;
    overflow: auto;
  }

  .ticket-count-tile {
    min-height: 120px;
    display: flex;
    align-items: center;
  }

</style>
